// src/components/ui/ErrorAlert.tsx

import { Alert } from 'antd';
import type { AlertProps } from 'antd';

/**
 * 全局错误提示组件
 * 封装 Ant Design Alert，提供一致的错误展示样式
 */
export const ErrorAlert = ({ 
  message, 
  description,
  ...props 
}: {
  message: string;
  description?: string;
} & Omit<AlertProps, 'message' | 'description' | 'type'>) => {
  return (
    <Alert
      type="error"
      showIcon
      message={message}
      description={description}
      className="mb-4"
      {...props}
    />
  );
};